module.exports = __webpack_public_path__ + "static/img/khk002b-1.643214c9.jpg";